import { Link } from "react-router-dom";
import { Magnetic } from "./Magnetic";
import { CHECKUP_URL } from "../../config";

// Primary = filled warm-white; ghost = bordered; text = inline arrow link.
export const CtaButton = ({
  children,
  to,
  onClick,
  variant = "primary",
  className = "",
  testid,
  arrow = "→",
}) => {
  const base =
    "group inline-flex items-center gap-3 font-mono text-[12px] tracking-[0.18em] uppercase transition-colors duration-500 select-none";
  const styles = {
    primary:
      "px-7 py-4 bg-[#f5f3ee] text-[#0E1526] hover:bg-[#5CCBF5] hover:text-white",
    ghost:
      "px-7 py-4 border border-white/15 text-[#f5f3ee] hover:border-[#5CCBF5] hover:text-[#5CCBF5] bg-transparent",
    text: "text-[#a7a7a2] hover:text-[#f5f3ee]",
  };
  const inner = (
    <>
      <span>{children}</span>
      <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">
        {arrow}
      </span>
    </>
  );
  const cls = `${base} ${styles[variant]} ${className}`;

  const dest = to === "/apply" ? CHECKUP_URL : to;
  const content = !dest ? (
    <button type="button" className={cls} data-testid={testid} onClick={onClick}>
      {inner}
    </button>
  ) : dest.startsWith("http") ? (
    <a href={dest} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testid} onClick={onClick}>
      {inner}
    </a>
  ) : (
    <Link to={dest} className={cls} data-testid={testid} onClick={onClick}>
      {inner}
    </Link>
  );

  return <Magnetic strength={0.25} className="inline-block">{content}</Magnetic>;
};

export default CtaButton;
